import { create } from "zustand";
import { IUserApp } from "@/types/user.types";
import selectColorTypeApp from "@/components/common/selectColorApp";

export const useUserApp = create<IUserApp>((set) => ({
  data: {
    name: "",
    dynamic: "1",
    design_colors_primary: selectColorTypeApp[0].color,
    logo: "",
    logo_name: "",
    logo_type: "",
    logo_path: "",
    title: "",
    description: "",
    website: "",
    welcome_screen: "",
    welcome_path: "",
    app_name: "",
    developer: "",
    button: "",
    button_url: "",
    app_store: "",
    google_play: "",
    showButton: false,
    socialItems: [
      {
        id: 0,
        icon: "/social-items/app-store.svg",
        url: "",
        type: "app_store",
        active: false,
        text: "Apple Store",
      },
      {
        id: 1,
        icon: "/social-items/google-play.svg",
        url: "",
        type: "google_play",
        active: false,
        text: "Google Play",
      },
    ],
  },
  config: {},
  addButton: [
    {
      value: "Learn more",
      icon: "",
    },
    {
      value: "View more apps",
      icon: "",
    },
    {
      value: "Watch the video",
      icon: "",
    },
    {
      value: "Custom",
      icon: "/common/edit-icon.svg",
    },
  ],
  socialTypes: [
    {
      icon: "/social-items/app-store.svg",
      text: "Apple Store",
      type: "app_store",
      active: false,
    },
    {
      icon: "/social-items/google-play.svg",
      text: "Google Play",
      type: "google_play",
      active: false,
    },
    {
      icon: "/social-items/amazon.svg",
      text: "Amazon",
      type: "amazon",
      active: false,
    },
  ],
  setDeleteUserApp: (val) => {
    set((state) => {
      delete state[val as keyof typeof state];

      return { ...state };
    });
  },
  destroyUserApp: () => {
    set({
      data: {
        name: "",
        dynamic: "1",
        design_colors_primary: selectColorTypeApp[0].color,
        logo: "",
        logo_name: "",
        logo_type: "",
        logo_path: "",
        title: "",
        description: "",
        website: "",
        welcome_screen: "",
        welcome_path: "",
        app_name: "",
        developer: "",
        button: "",
        button_url: "",
        app_store: "",
        google_play: "",
        showButton: false,
        socialItems: [
          {
            id: 0,
            icon: "/social-items/app-store.svg",
            url: "",
            type: "app_store",
            active: false,
            text: "Apple Store",
          },
          {
            id: 1,
            icon: "/social-items/google-play.svg",
            url: "",
            type: "google_play",
            active: false,
            text: "Google Play",
          },
        ],
      },
      config: {},
      addButton: [
        {
          value: "Learn more",
          icon: "",
        },
        {
          value: "View more apps",
          icon: "",
        },
        {
          value: "Watch the video",
          icon: "",
        },
        {
          value: "Custom",
          icon: "/common/edit-icon.svg",
        },
      ],
      socialTypes: [
        {
          icon: "/social-items/app-store.svg",
          text: "Apple Store",
          type: "app_store",
          active: false,
        },
        {
          icon: "/social-items/google-play.svg",
          text: "Google Play",
          type: "google_play",
          active: false,
        },
        {
          icon: "/social-items/amazon.svg",
          text: "Amazon",
          type: "amazon",
          active: false,
        },
      ],
    });
  },
  setUserApp: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setScreenImage: (val: string) => {
    set((state) => {
      return { ...state, screenImage: val };
    });
  },
  setShowButton: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, showButton: val } };
    });
  },
  setReorderSocial: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          socialItems: val,
        },
      };
    });
  },
  setDeleteSocialItem: (index, qrShowId) => {
    set((state) => {
      const afterDeleted = state.data.socialItems.filter((e, i) => {
        if (qrShowId) {
          e.id = e.id > 0 ? e.id - 1 : e.id;
        }

        return i !== index;
      });

      return {
        ...state,
        data: {
          ...state.data,
          socialItems: afterDeleted,
        },
      };
    });
  },
  setSocialItems: (val, type, index, action) => {
    set((state) => {
      if (type === "add") {
        return {
          ...state,
          data: {
            ...state.data,
            socialItems: [...state.data.socialItems, val],
          },
        };
      }
      if (type === "update_value" && action) {
        (state.data.socialItems[index] as any)[action] = val;
        return { ...state };
      } else {
        return { ...state, socialItems: val };
      }
    });
  },
  setSocialTypes: (val) => {
    set((state) => {
      const newSocialTypesState = state.socialTypes.map((obj) => {
        if (
          obj.type.toUpperCase().replace(/\s+/g, "") === val.type.toUpperCase().replace(/\s+/g, "")
        ) {
          return { ...obj, active: val.active };
        }

        return obj;
      });

      return { ...state, socialTypes: newSocialTypesState };
    });
  },
  setDeleteSocialTypes: (val) => {
    set((state) => {
      const deleted = state.data.socialItems.filter(
        (e) =>
          e.type.toUpperCase().replace(/\s+/g, "") !== val.type.toUpperCase().replace(/\s+/g, ""),
      );

      return {
        ...state,
        data: {
          ...state.data,
          socialItems: deleted,
        },
      };
    });
  },
}));
